module.exports = __webpack_public_path__ + "static/media/stofferingen-09.0625d967.jpg";